import React, { PureComponent } from 'react';
import { SidePanelContext } from '../../SidePanelAPI';
import PropTypes from 'prop-types';
import { st, classes } from './Header.st.css.js';
import { dataHooks } from '../../constants';
import Heading from '../../../Heading';
import Divider from '../../../Divider';
import CloseButton from '../../../CloseButton';
import Box from '../../../Box';
import InfoIcon from '../../../InfoIcon';
import Text from '../../../Text';
import { TooltipCommonProps } from '../../../common/PropTypes/TooltipCommon';
import { WixDesignSystemContext } from '../../../WixDesignSystemProvider/context';
import { Help24 as Help } from '@wix/wix-ui-icons-common/system';
import { ChevronLeftLarge } from '@wix/wix-ui-icons-common';
import Tooltip from '../../../Tooltip';
class Header extends PureComponent {
    renderStringTitle(skin) {
        const { title, infoTooltipContent, infoTooltipProps, maxLines, ellipsis } = this.props;
        const headerProps = {
            placement: 'auto',
            ellipsis,
            maxLines,
            size: 'medium',
            as: 'h2',
            dataHook: dataHooks.sidePanelHeaderTitle,
        };
        const HeaderText = () => skin === 'floating' ? (React.createElement(Text, { ...headerProps, weight: "bold" }, title)) : (React.createElement(Heading, { ...headerProps }, title));
        return (React.createElement(Box, null,
            React.createElement(HeaderText, null),
            infoTooltipContent && (React.createElement(Box, { marginLeft: "tiny" },
                React.createElement(InfoIcon, { dataHook: dataHooks.sidePanelHeaderTitleInfoIcon, content: infoTooltipContent, tooltipProps: infoTooltipProps })))));
    }
    renderSubtitle() {
        const { subtitle } = this.props;
        if (!subtitle)
            return null;
        const isStringSubtitle = typeof subtitle === 'string';
        if (!isStringSubtitle) {
            return subtitle;
        }
        return (React.createElement(Text, { skin: "standard", secondary: true, dataHook: dataHooks.sidePanelHeaderSubtitle }, subtitle));
    }
    renderBackButton(onBackButtonClick, backButtonDescription, backButtonTooltipProps) {
        const backButton = (React.createElement(CloseButton, { dataHook: dataHooks.sidePanelHeaderBackButton, className: classes.backButton, onClick: onBackButtonClick, size: "large", skin: "dark", children: React.createElement(ChevronLeftLarge, null) }));
        if (backButtonDescription) {
            return (React.createElement(Tooltip, { ...backButtonTooltipProps, content: backButtonDescription, dataHook: dataHooks.sidePanelHeaderBackButtonTooltip }, backButton));
        }
        return backButton;
    }
    renderTitle(onCloseButtonClick, onHelpButtonClick, skin, onBackButtonClick, backButtonDescription, backButtonTooltipProps) {
        const { title } = this.props;
        const isStringTitle = typeof title === 'string';
        return (React.createElement("div", { className: st(classes.titleContainer, {
                noCloseButton: !onCloseButtonClick,
            }) },
            this.props.prefix && (React.createElement("div", { "data-hook": dataHooks.sidePanelHeaderPrefix }, this.props.prefix)),
            onBackButtonClick &&
                this.renderBackButton(onBackButtonClick, backButtonDescription, backButtonTooltipProps),
            React.createElement("div", { className: classes.title },
                isStringTitle ? this.renderStringTitle(skin) : title,
                this.renderSubtitle()),
            this.renderButtons(onCloseButtonClick, onHelpButtonClick)));
    }
    renderButtons(onCloseButtonClick, onHelpButtonClick) {
        if (!onCloseButtonClick && !onHelpButtonClick && !this.props.suffix) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: classes.buttonBox },
            this.props.suffix && (React.createElement("div", { "data-hook": dataHooks.sidePanelHeaderSuffix }, this.props.suffix)),
            onHelpButtonClick && (React.createElement(CloseButton, { dataHook: dataHooks.sidePanelHeaderHelpButton, className: classes.helpButton, onClick: onHelpButtonClick, size: "large", skin: "dark", children: React.createElement(Help, { className: classes.helpIcon }) })),
            onCloseButtonClick && (React.createElement(CloseButton, { dataHook: dataHooks.sidePanelHeaderCloseButton, className: classes.closeButton, onClick: onCloseButtonClick, size: "large", skin: "dark" }))));
    }
    render() {
        const { children, showDivider, className } = this.props;
        return (React.createElement(SidePanelContext.Consumer, null, ({ skin, isDraggable, onCloseButtonClick, onHelpButtonClick, onBackButtonClick, backButtonDescription, backButtonTooltipProps, }) => (React.createElement(WixDesignSystemContext.Consumer, null, ({ newColorsBranding }) => (React.createElement("div", { className: st(classes.root, { newColorsBranding, skin, isDraggable }, className), "data-hook": dataHooks.sidePanelHeader },
            this.renderTitle(onCloseButtonClick, onHelpButtonClick, skin, onBackButtonClick, backButtonDescription, backButtonTooltipProps),
            children,
            showDivider && (React.createElement(Divider, { dataHook: dataHooks.sidePanelHeaderDivider }))))))));
    }
}
Header.displayName = 'SidePanel.Header';
Header.propTypes = {
    className: PropTypes.string,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    infoTooltipContent: PropTypes.node,
    infoTooltipProps: PropTypes.shape(TooltipCommonProps),
    showDivider: PropTypes.bool,
    children: PropTypes.node,
    maxLines: PropTypes.number,
    ellipsis: PropTypes.bool,
};
Header.defaultProps = {
    showDivider: true,
};
export default Header;
//# sourceMappingURL=Header.js.map